import { render, staticRenderFns } from "./Newfhk.vue?vue&type=template&id=922de352&scoped=true&"
import script from "./Newfhk.vue?vue&type=script&lang=js&"
export * from "./Newfhk.vue?vue&type=script&lang=js&"
import style0 from "./Newfhk.vue?vue&type=style&index=0&id=922de352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922de352",
  null
  
)

export default component.exports